import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { policySelector, claimSelector, profileSelector } from '../../selectors';
import * as claimActions from '../../actions/claimActions';
import Section from '../../components/Section';
import { Claim } from '../../components/sections';
import Pagination from '../../components/Pagination';
import { Menu, Icon } from 'semantic-ui-react';
import { push } from 'connected-react-router';
// eslint-disable-next-line no-unused-vars
import moment, { isDate } from 'moment';
import ConfirmationModal from '../../components/sections/claim/ConfirmationModal';

class ClaimSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activePage: 1,
			itemsPerPage: 3,
			startIndex: 0,
			endIndex: 3,
            showReportModal: false,
            confirmationDialog: false,
		};
		this.onPaginate = this.onPaginate.bind(this);
		this.onShowEDeliverySettings = this.onShowEDeliverySettings.bind(this);
		this.onShowReportClaim = this.onShowReportClaim.bind(this);
        this.onReportClaim = this.onReportClaim.bind(this);
        this.onReportClaimFieldChange = this.onReportClaimFieldChange.bind(this);
        this.onCancelReportClaim = this.onCancelReportClaim.bind(this);
        this.onShowReportClaimModal = this.onShowReportClaimModal.bind(this);
	}
	onPaginate({ activePage, startIndex, endIndex }) {
		this.setState({ activePage, startIndex, endIndex });
	}


	onCancelReportClaim(e) {
		const { actions } = this.props;
		this.setState({ showReportModal: false });
		actions.resetClaim();
    }

	onReportClaimFieldChange(e, data) {
	    const { actions, claim } = this.props;
	    if (isDate(e)) {
		    claim.lossDate = e;
		} else if (!data) {
		    claim[e.target.name] = e.target.value;
        } else {
		    if (data.name === 'policyNumber') {
			    const lossType = (v) => {
				    switch (v.substring(0, 3)) {
                        case 'PPA':
				        case 'CAP':
				            return [
					            {
                                    key: 'Auto',
					                text: 'Auto',
					                value: 'Auto',
					            },
			                ];
			            case 'BOP':
			            case 'CRM':
			            case 'DFR':
			            case 'FAR':
			            case 'HOM':
			                return [
			                    {
                                    key: 'Person',
                                    text: 'Person/Liability',
                                    value: 'Person',
                                },
                                {
                                    key: 'Property',
                                    text: 'Property',
                                    value: 'Property',
                                },
                            ];
                        case 'CGL':
                        case 'CUP':
                        case 'PUP':
                        case 'FUP':
                            return [
                                {
                                    key: 'Person',
                                    text: 'Person/Liability',
                                    value: 'Person',
                                },
                            ];
                        case 'CIM':
                        case 'CPR':
                        case 'PIM':
                            return [
	                            {
                                    key: 'Property',
                                    text: 'Property',
                                    value: 'Property',
                                },
                            ];
                        case 'GAR':
                            return [
                                {
                                    key: 'Person',
                                    text: 'Person/Liability',
                                    value: 'Person',
                                },
                                {
                                    key: 'Auto',
                                    text: 'Auto',
                                    value: 'Auto',
                                },
                            ];
                        case 'CPP':
                            return [
                                {
                                    key: 'Person',
                                    text: 'Person/Liability',
                                    value: 'Person',
                                },
                                {
                                    key: 'Auto',
                                    text: 'Auto',
                                    value: 'Auto',
                                },
                                {
                                    key: 'Property',
                                    text: 'Property',
                                    value: 'Property',
                                },
                            ];
                        default:
                            return [];
                    }
				};
				claim.lossTypeOptions = lossType(data.value);
			}
            if (data.type === 'checkbox') {
	            claim[data.name] = data.checked;
	        } else {
					claim[data.name] = data.value;
				}
		}
		actions.updateClaim(claim);
	}

	async onReportClaim(e) {
	    try {
	    	const { actions, claim } = this.props;
		    await actions.submitClaim(claim);
		    this.setState({ showReportModal: false, reportError: null });
		    this.setState({ confirmationDialog: true });
		} catch (error) {
		    this.setState({ reportError: error.message });
		}
	}

	onShowReportClaimModal(e) {
	    const { actions, claim, profile } = this.props;
	    claim.policyHolder = profile.name;
	    claim.emailAddress = profile.email;
	    claim.phoneNumber = profile.phoneNumber;
	    actions.updateClaim(claim);
	    this.setState({ showReportModal: true });
	}

	onShowEDeliverySettings(e) {
		const { actions } = this.props;
		actions.push('/profile/alerts');
	}

	onShowReportClaim() {
		const { actions } = this.props;
		actions.push('/report-claim');
	}

	render() {
        const confirmationModal = <ConfirmationModal showAlertOnly open={this.state.confirmationDialog} onClose={() => this.setState({ confirmationDialog: false })} onOpen={() => this.setState({ confirmationDialog: true })} header='Claim Confirmation'>
			<p>You have successfully submitted your claim! We will be in touch soon.</p>
		</ConfirmationModal>;
        const { policy, claim, profile } = this.props;
		const { itemsPerPage, startIndex, endIndex, showReportModal, reportError } = this.state;

		let claims = [];
		for (let index = 0; index < policy.items.length; index++) {
			const item = policy.items[index];
			if (item.claims && item.claims.length > 0) {
				claims = [
					...claims,
					...item.claims.map((c) => {
						return { ...c, policy: item };
					}),
				];
			}
		}


		claims = claims.sort((p1, p2) => Number(new Date(p2.lossDate)) - Number(new Date(p1.lossDate)),);

		const page = claims.slice(startIndex, endIndex);
		return (
			<div>
                {this.state.confirmationDialog && confirmationModal}
				<Section name='claims' title='Claims' color='orange' mobileShow={this.props.mobileShow}>
                    <Claim.ModalReportClaim error={reportError} open={showReportModal} onCancel={this.onCancelReportClaim} onReportClaim={this.onReportClaim} onFieldChange={this.onReportClaimFieldChange} data={{ policy, claim, profile }} />

					<Menu pointing secondary stackable>
						<Menu.Menu position='right'>
							<Menu.Item onClick={this.onShowEDeliverySettings}>
								<Icon size='large' name='mobile alternate' /> Sign Up for Emails/Texts About Your Claim
							</Menu.Item>
							<Menu.Item
								name='report claim'
								size='huge'
								onClick={this.onShowReportClaim} //this.onShowReportClaimModal
								icon={
									<Icon.Group size='large'>
										<Icon name='handshake' />
									</Icon.Group>
								}
                                
							/>
						</Menu.Menu>
					</Menu>
					<Claim.List>
						{page.map((c, i) => (
							<Claim key={i} claim={c} />
						))}
					</Claim.List>

					<div>
						<Pagination activePage={this.state.activePage} itemsPerPage={itemsPerPage} totalItems={claims.length} pageRangeDisplayed={5} onPaginate={this.onPaginate} />
					</div>
				</Section>
			</div>
		);
	}
}

ClaimSection.propTypes = {
	actions: PropTypes.object.isRequired,
	policy: PropTypes.object.isRequired,
	claim: PropTypes.object.isRequired,
	profile: PropTypes.object.isRequired,
	mobileShow: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
	return {
		policy: policySelector(state),
		claim: claimSelector(state),
		profile: profileSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(claimActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ClaimSection);
